import React from 'react'
import ReactDOM from 'react-dom/client'
import './styles/index.css'
import { App } from './App'
import { applyTintToRoot, loadTint } from './ui/paperTint'

// One-time migration: the localStorage keys were renamed from the
// legacy "orizuru-*" prefix to "origami-*" with the brand rename to
// Origami Arena. Copy values forward so existing users don't lose
// their theme/tint preferences. Runs before any code reads the keys.
function migrateStorageKey(oldKey: string, newKey: string): void {
  if (typeof window === 'undefined') return
  try {
    if (window.localStorage.getItem(newKey) !== null) return
    const oldVal = window.localStorage.getItem(oldKey)
    if (oldVal === null) return
    window.localStorage.setItem(newKey, oldVal)
    window.localStorage.removeItem(oldKey)
  } catch {
    /* ignore — private mode, quota, etc. */
  }
}
migrateStorageKey('orizuru-theme', 'origami-theme')
migrateStorageKey('orizuru-tint', 'origami-tint')

// Apply the saved paper tint to <html> before React mounts so the
// first paint is already tinted — avoids a flash of the default.
applyTintToRoot(loadTint())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
